export default {"src":"/_next/static/media/whoop-loading-dark-mode.1efcf824.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};